import { routes } from '@redwoodjs/router'

import { parseViewUuidFromSearch, VIEW_UUID_QUERY_PARAM } from './parseViewUuidFromSearch'

/** Query param for deep-linking to a saved table view on the staff inspections list. */
export const INSPECTIONS_LIST_VIEW_UUID_QUERY_PARAM = VIEW_UUID_QUERY_PARAM

export const parseInspectionsListViewUuidFromSearch = parseViewUuidFromSearch

export const inspectionsListPathWithViewUuid = ({
  recordTypeId,
  viewUuid,
}: {
  recordTypeId: number
  viewUuid: string
}) => {
  const path = routes.recordsInspections({ recordTypeId })
  const params = new URLSearchParams({ [INSPECTIONS_LIST_VIEW_UUID_QUERY_PARAM]: viewUuid })
  return `${path}?${params.toString()}`
}
